'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _d3Transition = require('d3-transition');

var _d3Interpolate = require('d3-interpolate');

var _datajoin2 = require('./datajoin');

var _datajoin3 = _interopRequireDefault(_datajoin2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var extent = function extent(collection, accessor) {
  var min = Infinity,
      max = -Infinity;
  for (var i = 0; i < collection.length; i++) {
    var value = accessor ? accessor(collection[i]) : collection[i];
    if (value < min) min = value;
    if (value > max) max = value;
  }
  return [min, max];
};

var zip = function zip(a, b) {
  return a.map(function (d, i) {
    return [d, b[i]];
  });
};

var nextId = 0;

var JoinTransition = function (_Component) {
  _inherits(JoinTransition, _Component);

  function JoinTransition() {
    _classCallCheck(this, JoinTransition);

    return _possibleConstructorReturn(this, (JoinTransition.__proto__ || Object.getPrototypeOf(JoinTransition)).apply(this, arguments));
  }

  _createClass(JoinTransition, [{
    key: 'render',
    value: function render() {
      return this.props.children(this.state.values, this.state.prevValues);
    }
  }, {
    key: 'setValues',
    value: function setValues(values) {
      this.setState({ values: values, prevValues: values });
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setValues(this.props.values);
      this.id = nextId++;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.transition != null) {
        this.transition.selection().interrupt('JoinTransition-' + this.id);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      var _this2 = this;

      if (typeof props.shouldTransition === 'function' ? !props.shouldTransition(this.props.values, props.values) : !props.shouldTransition) {
        return this.setValues(props.values);
      }

      var plural = Array.isArray(props.values);

      this.transition = !props.queue || !this.transition ? (0, _d3Transition.transition)('JoinTransition-' + this.id) : this.transition.transition();

      var defaultEase = this.transition.ease();
      if (props.duration != null) this.transition.duration(props.duration);
      if (plural) this.transition.ease(function (t) {
        return +t;
      });else if (props.ease != null) this.transition.ease(props.ease);

      var enterValue = props.enter || props.enterOrExit;
      var exitValue = props.exit || props.enterOrExit;
      var enterFrom = typeof enterValue === 'function' ? enterValue : function (d) {
        return _extends({}, d, enterValue);
      };
      var exitTo = typeof exitValue === 'function' ? exitValue : function (d) {
        return _extends({}, d, exitValue);
      };

      var interpolator = void 0;

      if (plural) {
        (function () {
          var _datajoin = (0, _datajoin3.default)(_this2.state.values, props.values, {
            key: props.identify, enterFrom: enterFrom, exitTo: exitTo
          });

          var before = _datajoin.before;
          var after = _datajoin.after;

          var interpolators = zip(before, after).map(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2);

            var from = _ref2[0];
            var to = _ref2[1];
            return props.interpolate(from, to, _d3Interpolate.interpolate);
          });

          var staggerAmount = typeof props.stagger === 'function' ? props.stagger(before, after) : props.stagger,
              staggerCoefficient = 1 / (1 - staggerAmount),
              staggerRange = props.orderBy ? extent(after, props.orderBy) : [0, after.length - 1],
              staggerRangeSize = staggerRange[1] - staggerRange[0],
              staggerScale = staggerRangeSize === 0 ? function () {
            return 0;
          } : function (value) {
            return (value - staggerRange[0]) / staggerRangeSize;
          };

          interpolator = function interpolator(t) {
            return after.map(function (d, i) {
              var staggerValue = props.orderBy != null ? props.orderBy(d, i) : i;
              var t_i = staggerCoefficient * t + (1 - staggerCoefficient) * staggerScale(staggerValue);
              var ease = props.ease != null ? props.ease : defaultEase;
              return _extends({}, d, interpolators[i](ease(Math.min(1, Math.max(0, t_i)))));
            });
          };
        })();
      } else if (this.state.values != null || props.values != null) {
        interpolator = props.interpolate(this.state.values == null ? enterFrom(props.values) : this.state.values, props.values == null ? exitTo(this.state.values) : props.values, _d3Interpolate.interpolate);
      } else return this.setValues(props.values);

      this.setState({ values: interpolator(0), prevValues: interpolator(0) });
      this.transition.tween('values', function () {
        return function (t) {
          _this2.setState({ values: interpolator(t), prevValues: _this2.state.values });
        };
      }).on('end', function () {
        _this2.setValues(props.values);
        _this2.transition = null;
        props.onTransitionEnd && props.onTransitionEnd();
      });
    }
  }]);

  return JoinTransition;
}(_react.Component);

JoinTransition.propTypes = {
  values: _propTypes2.default.any.isRequired,
  children: _propTypes2.default.func.isRequired,

  interpolate: _propTypes2.default.func,
  shouldTransition: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.bool]),
  queue: _propTypes2.default.bool,
  duration: _propTypes2.default.number,
  ease: _propTypes2.default.func,
  onTransitionEnd: _propTypes2.default.func,

  identify: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  enter: _propTypes2.default.oneOfType([_propTypes2.default.any, _propTypes2.default.func]),
  exit: _propTypes2.default.oneOfType([_propTypes2.default.any, _propTypes2.default.func]),
  enterOrExit: _propTypes2.default.oneOfType([_propTypes2.default.any, _propTypes2.default.func]),
  stagger: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
  orderBy: _propTypes2.default.func
};
JoinTransition.defaultProps = {
  interpolate: _d3Interpolate.interpolate,
  shouldTransition: function shouldTransition(a, b) {
    return a !== b;
  },
  queue: false,
  duration: null,
  ease: null,

  identify: 'id',
  enter: null,
  exit: null,
  stagger: 0,
  orderBy: null
};
exports.default = JoinTransition;


//////////////////
// WEBPACK FOOTER
// ./~/join-transition/dist/JoinTransition.js
// module id = 261
// module chunks = 0